module.exports = __webpack_public_path__ + "static/media/kebap.27b53bf3.png";